@if (count() > 0) {
  <div ngbDropdown placement="bottom-end" class="d-inline-block">
    <button
      type="button"
      class="notif-btn position-relative dropdown-toggle-no-caret"
      id="pendingNotifications"
      ngbDropdownToggle
      [title]="count() + ' pending'"
    >
      <fa-icon [icon]="icons.alert"></fa-icon>
      <span class="notif-badge">{{ count() }}</span>
    </button>
    <div ngbDropdownMenu aria-labelledby="pendingNotifications" class="dropdown-menu dropdown-menu-end notif-menu">
      <h6 class="dropdown-header">Pending</h6>
      @for (item of pending(); track item.org_id) {
        <div class="px-3 py-2 d-flex align-items-center gap-2">
          <div class="flex-grow-1">
            <div class="fw-semibold">{{ item.name }}</div>
            <small class="text-muted">
              @if (isCollaborator(item)) {
                Invited you to admin this organization
              } @else {
                Invited you to join
              }
            </small>
          </div>
          <button
            type="button"
            class="btn btn-sm btn-outline-success"
            [disabled]="isBusy(item)"
            (click)="accept(item)"
            title="Accept"
          >
            <fa-icon [icon]="icons.accept"></fa-icon>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            [disabled]="isBusy(item)"
            (click)="decline(item)"
            title="Decline"
          >
            <fa-icon [icon]="icons.decline"></fa-icon>
          </button>
        </div>
      }
    </div>
  </div>
}
